import React, { useState, useEffect } from "react"

const PhotoSlider = ({ photos, fallbackIcon, alt }) => {
  const [current, setCurrent] = useState(0)

  const hasPhotos = photos?.length > 0
  const isMultiple = photos?.length > 1

  const prev = (e) => {
    e.stopPropagation()
    setCurrent((c) => (c - 1 + photos.length) % photos.length)
  }
  const next = (e) => {
    e.stopPropagation()
    setCurrent((c) => (c + 1) % photos.length)
  }

  return (
    <div className="relative w-24 sm:w-32 h-20 sm:h-24 shrink-0 rounded-xl overflow-hidden bg-gray-50 border border-gray-100">
      {hasPhotos ? (
        <img
          src={photos[current]}
          alt={alt}
          className="w-full h-full object-contain p-1.5"
          onError={(e) => {
            e.currentTarget.src = fallbackIcon
          }}
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center p-3">
          <img src={fallbackIcon} alt={alt} className="w-full h-full object-contain" />
        </div>
      )}

      {isMultiple && (
        <>
          <button
            onClick={prev}
            className="absolute left-0.5 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-black/40 text-white flex items-center justify-center text-xs leading-none hover:bg-black/60 transition-colors"
            aria-label="Previous photo"
          >
            ‹
          </button>
          <button
            onClick={next}
            className="absolute right-0.5 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-black/40 text-white flex items-center justify-center text-xs leading-none hover:bg-black/60 transition-colors"
            aria-label="Next photo"
          >
            ›
          </button>

          <div className="absolute bottom-1 left-1/2 -translate-x-1/2 flex gap-0.5">
            {photos.map((_, i) => (
              <button
                key={i}
                onClick={(e) => {
                  e.stopPropagation()
                  setCurrent(i)
                }}
                className={`w-1 h-1 rounded-full transition-colors ${
                  i === current ? "bg-white" : "bg-white/50"
                }`}
                aria-label={`Photo ${i + 1}`}
              />
            ))}
          </div>

          <div className="absolute top-1 right-1 bg-black/45 text-white text-[9px] rounded-full px-1.5 py-px leading-4">
            {current + 1}/{photos.length}
          </div>
        </>
      )}
    </div>
  )
}

export default PhotoSlider
